import script from "./GPTIframeBanner320Slot1.vue?vue&type=script&setup=true&lang=js"
export * from "./GPTIframeBanner320Slot1.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__